
import GlobalVehicleSelect from '@components/new-styleguide/GlobalVehicleSelect.vue';
import Vue from "vue";
import { Component, Prop } from 'vue-property-decorator';
import BackIcon from '@components/icons/icon-back.svg';
import PlusIcon from '@components/icons/icon-plus.svg';
import { TripLog } from "@/generated-clients/myTrips";
import IconFilter from '@components/icons/icon-filter-rect.svg';
import IconSettings from '@components/icons/icon-settings.svg';
import IconImport from '@components/icons/icon-import.svg';
import { namespace } from 'vuex-class';
import { LoadState } from "@/utils/types";
import { RawLocation } from "vue-router";
import { RouterFrom } from '@/router/Routes';

const TriplogModule = namespace('Triplog');
const RouterModule = namespace('Router');

@Component({
  name: 'AppVehicleHeader',
  components: {
    GlobalVehicleSelect,
    BackIcon,
    PlusIcon,
    IconFilter,
    IconImport,
    IconSettings
  }
})
export default class AppVehicleHeader extends Vue {
  @RouterModule.State('from')
  private from: RouterFrom;

  @TriplogModule.Getter('getVehiclesStatus')
  private triplogsStatus: LoadState;

  @TriplogModule.Getter('getVehicles')
  private triplogs: TripLog[];

  @TriplogModule.Getter('getSelectedTriplog')
  private selectedTriplog: TripLog;

  @Prop()
  private backLocation: RawLocation;

  @Prop({ default: false })
  private loading: boolean;

  @Prop({ default: true })
  private showAllVehiclesOption: boolean;

  @Prop({ default: false })
  private showExport: boolean;

  @Prop({ default: true })
  private showFilter: boolean;

  private handleBackClicked() {
    if (this.from.name) {
      this.$router.back();
    } else {
      this.$router.replace(this.backLocation);
    }
  }

  get renderVehicleSelect() {
    return !this.requestLoading && this.selectedTriplog !== null && this.triplogs.length > 1 && (this.showAllVehiclesOption || this.selectedTriplog);
  }

  get requestLoading() {
    return this.triplogsStatus !== LoadState.Success;
  }
}
